import { render } from "./MeteorShowers.vue?vue&type=template&id=bd42d86a&scoped=true"
import script from "./MeteorShowers.vue?vue&type=script&lang=js"
export * from "./MeteorShowers.vue?vue&type=script&lang=js"

import "./MeteorShowers.vue?vue&type=style&index=0&id=bd42d86a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.100.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd42d86a"]])

export default __exports__